import { Dropdown } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';
import type { InjectedRouter } from 'react-router';

import RouterLink from '../generic/Link/RouterLink';
import { LEGAL_AGENT_ACTIVITY_PATH } from '../legalAgent/paths';
import { useIsLegalAgentEnabled } from '../legalAgent/useIsLegalAgentEnabled';

import MenuItemLink from './MenuItemLink';

type Props = {
  routerPush: InjectedRouter['push'];
  pathname: string;
};

/**
 * Top-nav "Agents" dropdown, shown only to premium organizations with the Legal Agent flag.
 */
export const AgentsNavItem: VoidFunctionComponent<Props> = ({ routerPush, pathname }) => {
  const isLegalAgentEnabled = useIsLegalAgentEnabled();
  if (!isLegalAgentEnabled) {
    return null;
  }

  const isOnAgents = pathname.startsWith('/agents');

  return (
    <li className="nav-right link-dropdown-right" data-test-id="nav-agents">
      <Dropdown id="agents-nav-dropdown" pullRight>
        <Dropdown.Toggle className={isOnAgents ? 'active' : ''} useAnchor />
        <Dropdown.Menu className="nav-issues-dropdown">
          <MenuItemLink eventKey={LEGAL_AGENT_ACTIVITY_PATH} routerPush={routerPush}>
            Legal Agent
          </MenuItemLink>
        </Dropdown.Menu>
      </Dropdown>
      <RouterLink activeClassName="active" to={LEGAL_AGENT_ACTIVITY_PATH}>
        Agents
      </RouterLink>
    </li>
  );
};
